module.exports = __webpack_public_path__ + "static/mobile-29cdd5084095d6062cfef78d97c32d9c.jpg";